export default __webpack_public_path__ + "static/media/2930 spice rack B top.60615551.png";